// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"8ae81c3e","52":"5545c92a","77":"f579254a","88":"00c06f58","245":"aabda363","372":"1d885eed","496":"9e1fb1df","553":"6ce74419","583":"8d8152db","590":"fa7b60bf","665":"e6541909","739":"08165f32","819":"40b9bc70","825":"baf1e9ae","848":"df23c809"}[chunkId] + ".chunk.js";
};